import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {SearchList} from '../../search-list';
import {ObjectDetailTitle} from './object-detail-title.model';
import {TranslateService} from '../../../../shared/translate.service';
import {AuthService} from '../../../../auth/auth.service';
import {UserCollectionsService} from '../../../../auth/account/user-collections/user-collections.service';
import {MessageService} from '../../../../messages/message.service';
import {Router} from '@angular/router';
import {AppUtils} from '../../../../shared/app-utils';
import {Property} from '../../../../shared/property/property.model';
import {TranslatorService} from '../../../../shared/translator.service';
import {HttpClient} from "@angular/common/http";
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-result-item',
  templateUrl: './result-item.component.html',
  styleUrls: ['./result-item.component.css']
})
export class ResultItemComponent implements OnChanges {

  @Input() record: any;

  @Input() searchResult: SearchList;

  @Input() collectionMode = false;

  addToFavLabel = this.translateService.translate('ResultItem.addToFavourites');

  downloadLabel = this.translateService.translate('ResultItem.download');

  properties: Property[] = [];

  titleWrapper: ObjectDetailTitle;

  constructor(public translateService: TranslateService,
              private authService: AuthService,
              private translator: TranslatorService,
              private userCollections: UserCollectionsService,
              private messageService: MessageService,
              private router: Router,
              private http: HttpClient) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('record' in changes) {
      this.properties = AppUtils.mapObjectToProperties(this.record);
      this.titleWrapper = AppUtils.createTitleWrapper(this.record);
    }
  }

  removeFromFavourites() {
    this.authService.getToken().then(token => {
      this.userCollections.deleteUserCollectionItem(this.record['id'], this.record['type'], this.userCollections.lastUserCollection.id, token).then(result => {
        this.messageService.successMessage('UserCollection.removeItem', 'UserCollection.removeItem.desc');
        if (this.userCollections.lastUserCollection) {
          this.router.navigate(['/search/b'], {
            queryParams: {
              collectionId: this.userCollections.lastUserCollection.id,
              f: new Date().getMilliseconds()
            }
          })
        }
      }, error1 => {
        console.log(error1);
        this.messageService.errorMessage('UserCollection.removeItem.error', 'UserCollection.removeItem.desc.error');
      });
    });
  }

  isMuseumRecord() {
    return this.record['type'] === 'museum_object';
  }

  isWorkRecord() {
    return this.record['type'] === 'work';
  }

  isMatRecord() {
    return this.record['type'] === 'materialization';
  }
}
